export const Cookies = {
  get: (name) => {
    const matches = document.cookie.match(
      new RegExp('(?:^|; )' + encodeURIComponent(name).replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'),
    )
    if (!matches) {
      return undefined
    }
    const value = matches[1].replace(/\+/g, ' ')
    try {
      const decoded = decodeURIComponent(value)
      return JSON.parse(decoded)
    } catch {
      try {
        return decodeURIComponent(value)
      } catch {
        return value
      }
    }
  },

  set: (name, value, options = {}) => {
    options = { path: '/', ...options }
    const rawValue = typeof value === 'object' ? JSON.stringify(value) : String(value)
    const encodedValue = encodeURIComponent(rawValue)
    let updated = encodeURIComponent(name) + '=' + encodedValue

    if (options.expires) {
      let exp
      if (options.expires instanceof Date) {
        exp = options.expires.toUTCString()
      } else if (typeof options.expires === 'string' && /[smhd]/.test(options.expires)) {
        const parse = (str) => {
          let ms = 0
          const d = str.match(/(\d+)d/)
          const h = str.match(/(\d+)h/)
          const m = str.match(/(\d+)m/)
          const s = str.match(/(\d+)s/)
          if (d) {
            ms += +d[1] * 864e5
          }
          if (h) {
            ms += +h[1] * 36e5
          }
          if (m) {
            ms += +m[1] * 6e4
          }
          if (s) {
            ms += +s[1] * 1e3
          }
          return ms
        }
        exp = new Date(Date.now() + parse(options.expires)).toUTCString()
      } else if (typeof options.expires === 'number') {
        exp = new Date(Date.now() + options.expires * 864e5).toUTCString()
      } else {
        exp = String(options.expires)
      }
      updated += '; Expires=' + exp
    }

    Object.entries(options).forEach(([k, v]) => {
      if (k === 'expires') {
        return
      }
      if (v === true) {
        updated += '; ' + k
      } else if (v !== false) {
        updated += '; ' + k + '=' + v
      }
    })

    document.cookie = updated
  },

  remove: (name) => {
    Cookies.set(name, '', { 'max-age': -1 })
  },
}
